import {
  AddExternalGuestSubmitType,
  AddGuestSubmitType,
  BookingSaveApi,
  BookingSlotApi,
} from "@models/services/booking";
import { CalculatePriceApi } from "@models/services/pricing";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function getBookingSlot({
  bookingDate,
  locationId,
}: BookingSlotApi) {
  return await apiCall.get(
    `${API_URL.BOOKING.BOOKING_SLOT}${locationId}?bookingDate=${bookingDate}`,
    undefined,
    {},
    "v2"
  );
}

export async function getBookingEvents({
  bookingDate,
  locationId,
}: BookingSlotApi) {
  return await apiCall.get(
    `${API_URL.BOOKING.BOOKING_CALENDAR}${locationId}?bookingDate=${bookingDate}`,
    undefined,
    {},
    "v2"
  );
}

export async function getCalendarParticipant(bookingId: string) {
  return await apiCall.get(
    `${API_URL.BOOKING.CALENDAR_PARTICIPANT}${bookingId}/participants`,
    undefined,
    {},
    "v2"
  );
}

export async function saveBookingSlot(payload: BookingSaveApi) {
  return await apiCall.post(API_URL.BOOKING.BOOKING_SAVE, payload, {}, "v2");
}

export async function cancelBooking(bookingId: string) {
  return await apiCall.get(`${API_URL.BOOKING.CANCEL}${bookingId}`);
}

export async function calculatePrice(payload: CalculatePriceApi) {
  return await apiCall.post(
    `${API_URL.BOOKING.CALCULATE_PRICE}`,
    payload,
    {},
    "v2"
  );
}

export async function getQuoteInfo({
  bookingDate,
  locationId,
  selectedTime,
}: {
  locationId: string;
  bookingDate: string;
  selectedTime: string;
}) {
  return await apiCall.post(
    `${API_URL.BOOKING.GET_QUOTE_INFO}${locationId}`,
    {
      bookingDate,
      selectedTime,
    },
    {},
    "v2"
  );
}

export async function checkCancelFeasibility(bookingId: string) {
  return await apiCall.get(
    `${API_URL.BOOKING.CHECK_CANCEL_FEASIBILITY}${bookingId}`
  );
}

export async function getPaymentStatus(paymentId: string) {
  return await apiCall.get(`${API_URL.BOOKING.PAYMENT_STATUS}${paymentId}`);
}
export async function getGuestList(query: string) {
  return await apiCall.get(
    `${API_URL.BOOKING.GET_GUEST_LIST}${query}`,
    undefined,
    {},
    "v2"
  );
}
export async function checkGuestList(payload: AddGuestSubmitType) {
  return await apiCall.post(
    `${API_URL.BOOKING.CHECK_GUEST_LIST}`,
    payload,
    {},
    "v2"
  );
}
export async function addGuest(payload: AddGuestSubmitType) {
  return await apiCall.post(API_URL.BOOKING.ADD_GUEST, payload, {}, "v2");
}

export async function addExternalGuest(payload: AddExternalGuestSubmitType) {
  return await apiCall.post(
    API_URL.BOOKING.ADD_EXTERNAL_GUEST,
    payload,
    {},
    "v2"
  );
}
